
<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px"
        v-loading="loading">

        <el-row>
          <el-col :span="24">
            <el-form-item prop="sitePhoto" label="现场图片">
              <div class="row-wrap">

                <div class="images-wrap" v-if="formData.sitePhoto"  >
                  <el-image style="width: 100%; height: 100%" :src="formData.sitePhoto"
                    :preview-src-list="[formData.sitePhoto]" fit="cover" />
                </div>
              <div style="color:#999" v-else>暂无</div>

              </div>

            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'firefightingClockInDetail',

  data () {
    return {
      formData: {

        sitePhoto: ''

      },

      loading: false

    }
  },
  created () {
    if (this.clockId) {
      this.loadData()
    }
  },
  computed: {
    clockId () {
      return this.$route.query.clockId
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.firefightingClockIn.selectPaFireClockinByClockId, {
          params: { clockId: this.clockId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
